/* eslint-disable react-hooks/exhaustive-deps */
import {
  useNavigation,
  useFocusEffect,
  useIsFocused,
} from "@react-navigation/native";
import React, { useCallback, useMemo, useState } from "react";
import {
  ActivityIndicator,
  StyleSheet,
  View,
  FlatList,
  Text,
  TouchableOpacity,
  useWindowDimensions,
} from "react-native";
import CustomText from "@components/CustomText";
import colors from "@constants/color";
import { getIssuesList } from "@services/api";
import useSarvCall from "@hooks/useSarvCall";
import SarvCallModal from "@screens/MyTasks/components/SarvCallModal.tsx";
import debounce from "lodash/debounce";
import ComboCard from "@screens/MyDeliveries/components/ComboCard";
import PacketCard from "@screens/MyDeliveries/components/PacketCard";
import { meta } from "@constants/cplp";
import CxDetail from "./CxDetail";
import HeaderWithSearch from "../HeaderWithSearch";
import CrateCard from "./CrateCard";

function AllSamasya({ route }) {
  const navigation = useNavigation();
  const isFocused = useIsFocused();
  const [isLoading, setIsLoading] = useState(true);
  const [issuesList, setIssuesList] = useState([]);
  const [samasyaDetails, setSamasyaDetails] = useState({});
  const [isRefreshing, setIsRefreshing] = useState(false);
  const { height } = useWindowDimensions();
  const { createCall, showSarvModal, setShowSarvModal, updateSarvData } =
    useSarvCall();

  useFocusEffect(
    useCallback(() => {
      if (isFocused) {
        fetchData();
      }
    }, [isFocused]),
  );

  const fetchData = async () => {
    try {
      const { data } = await getIssuesList({
        date: route?.params?.date,
        spoke_name: route?.params?.spokeName,
      });
      setIssuesList(data?.issues_list);
      setSamasyaDetails(data);
      updateSarvData(data);
      setIsLoading(false);
      setIsRefreshing(false);
    } catch (error) {
      console.log(error);
    }
  };

  const onPressBadlav = (data) => {
    navigation.navigate("CrateItemList", {
      user_name: data?.user_name,
      orders_list: data?.orders_list,
      user_id: data?.user_id,
      user_phone: data?.user_phone,
      date: route?.params?.date,
      spokeName: route?.params?.spokeName,
    });
  };

  const renderItem = useCallback(({ item }) => {
    return (
      <View style={styles.itemContainer}>
        {item?.new_user && <NewTag />}
        <View style={{ paddingHorizontal: 16 }}>
          <CxDetail
            item={item}
            date={route?.params?.date}
            createCall={createCall}
          />
        </View>

        <View style={styles.subHeading}>
          <CustomText variant="body_text_4" style={styles.text}>
            {meta?.change_samasya}
          </CustomText>
          <TouchableOpacity
            testID="see_orders"
            onPress={() => onPressBadlav(item)}
          >
            <View style={{ flexDirection: "row" }}>
              <CustomText
                variant="body_text_2"
                style={{ textDecorationLine: "underline" }}
              >
                {meta?.change}
              </CustomText>
            </View>
          </TouchableOpacity>
        </View>
        {item?.items && Array.isArray(item.items)
          ? item.items.map((v) => {
              if (v?.type === "CRATE") {
                return v?.is_combo ? (
                  <View style={styles.cardsContainer}>
                    <ComboCard info={v} can_return={false} />
                  </View>
                ) : (
                  <View style={styles.cardsContainer}>
                    <CrateCard info={v} can_return={false} />
                  </View>
                );
              }
              if (v?.type === "SHIPMENT") {
                return v?.is_combo ? (
                  <View style={styles.cardsContainer}>
                    <CrateCard info={v} can_return={false} />
                  </View>
                ) : (
                  <View style={styles.cardsContainer}>
                    <PacketCard info={v} can_return={false} />
                  </View>
                );
              }
              return (
                <View style={styles.cardsContainer}>
                  <PacketCard info={v} can_return={false} />
                </View>
              );
            })
          : null}
      </View>
    );
  }, []);

  const sortUpdates = useMemo(
    () => () =>
      issuesList && Array.isArray(issuesList)
        ? issuesList?.filter(
            (v) => v?.items && Array.isArray(v?.items) && v?.items?.length,
          )
        : null,
    [issuesList],
  );

  const onPressCrossIcon = () => onSearchInputChange("");

  const onRefresh = () => {
    setIsRefreshing(true);
    fetchData();
  };

  function NewTag() {
    return (
      <View style={styles.newTag}>
        <Text style={styles.newTagText}>नया</Text>
      </View>
    );
  }

  const onSearchInputChange = debounce((text) => {
    const filteredData =
      samasyaDetails?.issues_list && Array.isArray(samasyaDetails?.issues_list)
        ? samasyaDetails?.issues_list.filter((data) => {
            return (
              containText(text, data?.user_name) ||
              containText(text, data?.user_phone) ||
              containText(text, data?.cx_formatted_address)
            );
          })
        : [];
    setIssuesList(filteredData);
  }, 500);

  const containText = (text, item) => {
    const lowerCasedText = text?.trim().toLowerCase();
    return item?.toLowerCase().includes(lowerCasedText);
  };

  const emptyComponent = () => (
    <View style={[styles.emptyContainer, { top: height * 0.1, height }]}>
      <CustomText variant="title_20" style={styles.text}>
        {meta?.return_already_raised}
      </CustomText>
    </View>
  );

  const keyExtractor = (item, index) => `${index}`;

  return (
    <View style={styles.container}>
      <HeaderWithSearch
        headertitle="दर्ज समस्या का रिटर्न लगाएं"
        headerColor="#fff"
        hideShadow={false}
        navigation={navigation}
        route={route}
        searchPlaceholder="कस्टमर के नाम, फ़ोन नंबर, एड्रेस से सर्च करें..."
        isSearchEnabled={true}
        onPressCrossIcon={onPressCrossIcon}
        onSearchInputChange={onSearchInputChange}
      />
      {isLoading ? (
        <View style={styles.loadingView}>
          <ActivityIndicator size="large" color={colors.primary} />
        </View>
      ) : (
        <FlatList
          keyExtractor={keyExtractor}
          contentContainerStyle={styles.containerStyle}
          data={sortUpdates()}
          renderItem={renderItem}
          keyboardShouldPersistTaps="handled"
          onRefresh={onRefresh}
          refreshing={isRefreshing}
          ListEmptyComponent={emptyComponent}
        />
      )}
      <SarvCallModal
        showSarvModal={showSarvModal}
        setShowSarvModal={setShowSarvModal}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  loadingView: {
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
    backgroundColor: colors.white,
  },
  container: {
    flex: 1,
  },
  itemContainer: {
    backgroundColor: "white",
    marginTop: 8,
    paddingTop: 16,
    overflow: "hidden",
  },
  subHeading: {
    justifyContent: "space-between",
    flexDirection: "row",
    paddingTop: 16,
    paddingHorizontal: 20,
  },
  text: { color: "rgba(0, 0, 0, 0.86)", textAlign: "center" },
  newTagText: {
    fontFamily: "NotoSansDevanagari-Bold",
    fontWeight: "700",
    fontSize: 11,
    color: "#FFFFFF",
    textAlign: "center",
  },
  newTag: {
    position: "absolute",
    left: -20,
    top: 3,
    height: 15,
    width: 60,
    alignItems: "center",
    justifyContent: "center",
    transform: [{ rotate: "-45deg" }],
    backgroundColor: "#00BA6E",
  },
  emptyContainer: { alignItems: "center", paddingHorizontal: 40 },
  cardsContainer: { paddingTop: 24 },
});

export default AllSamasya;
